import React, { useRef, useState, useEffect } from 'react';
import { Box, Avatar, Button, Grid } from '@mui/material';

const AVATAR_SIZE = 100;

const AvatarEditor = ({ value, availableAvatars = [], onSelectedAvatarChange }) => {
  const fileInputRef = useRef();
  const [selectedAvatar, setSelectedAvatar] = useState(value || '');

  useEffect(() => {
    setSelectedAvatar(value || '');
  }, [value]);

  useEffect(() => {
    if (onSelectedAvatarChange) onSelectedAvatarChange(selectedAvatar);
  }, [selectedAvatar, onSelectedAvatarChange]);

  // Determina se l'avatar è base64 o un nome file
  const getAvatarSrc = (avatar) => {
    if (!avatar) return '';
    if (avatar.startsWith('data:image/')) return avatar;
    // Assume sia un file in public/avatars
    return `/avatars/${avatar}`;
  };

  const handleAvatarClick = (avatar) => {
    setSelectedAvatar(avatar);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      setSelectedAvatar(ev.target.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <Avatar
          src={getAvatarSrc(selectedAvatar)}
          sx={{ width: AVATAR_SIZE, height: AVATAR_SIZE, fontSize: '2rem', bgcolor: 'primary.main' }}
        >
          {!selectedAvatar && '?'}
        </Avatar>
      </Box>
      <Grid container spacing={1} justifyContent="center">
        {availableAvatars.map((avatar) => (
          <Grid size={4} key={avatar}>
            <Avatar
              src={getAvatarSrc(avatar)}
              sx={{ 
                width: 80, 
                height: 80, 
                border: selectedAvatar === avatar ? '2px solid #1976d2' : '2px solid transparent', 
                cursor: 'pointer',
                mx: 'auto',
                display: 'block'
              }}
              onClick={() => handleAvatarClick(avatar)}
            />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 2, textAlign: 'center' }}>
        <input
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          ref={fileInputRef}
          onChange={handleFileChange}
        />
        <Button
          variant="outlined"
          size="small"
          sx={{ minHeight: 24, minWidth: 24, px: 1, py: 0, fontSize: '0.75rem', lineHeight: 1, mb: 2 }}
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
        >
          Carica immagine
        </Button>
      </Box>
    </Box>
  );
};

export default AvatarEditor; 